import(/* webpackMode: "eager" */ "/home/ubuntu/download/69b318a38d51a30014f91e0e/leadcore/src/app/partners/apply/page.tsx");
